import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase config - you'll need to replace these with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyADOfkQBIPjTGu1pII6WUXSijh-Z3l2QGo",
  authDomain: "effigen-client.firebaseapp.com",
  projectId: "effigen-client",
  storageBucket: "effigen-client.firebasestorage.app",
  messagingSenderId: "809846480730",
  appId: "1:809846480730:web:b5c2632f1d96ad30f3dd63",
  measurementId: "G-D6XY6LGRCN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export default app;
